
( ( $ ) => {

	const skipToContent = ( eve ) => {

		if (eve.type === 'click' || (eve.type === 'keydown' && eve.key === ' ')) {

			eve.preventDefault();

			const element_id = $( eve.currentTarget );
		
			if ( ! $( element_id ).length )
			{
				return;
			}

			let top_bars_subtract = 30;
			const target_area = $( element_id );
			const target_area_start = target_area.offset().top;
			
			if ( $( '.site-header' ).length )
			{
				top_bars_subtract += $( '.site-header' ).height();
			}

			if ( $( '#wpadminbar' ).length )
			{
				top_bars_subtract += $( '#wpadminbar' ).height();
			}

			const target_area_scroll_to = target_area_start - top_bars_subtract;

			$( 'html, body' ).animate( { 
				scrollTop: target_area_scroll_to 
			}, 300, function(){
				$('#primary').find('button:not([tabindex="-1"]), iframe, a:not([tabindex="-1"]), input:not([type="hidden"]), select:visible, textarea:visible, [tabindex]:not([tabindex="-1"])').first().focus();
				
				return false;
			});

		}
	}
       


	$( document ).on( 'click keydown', '[href="#primary"]', skipToContent );


} )( jQuery );